module.exports = __webpack_public_path__ + "media/images/pages/solutions/services/questionnaire_design-147b3148a0eebe41418f004a22c137f6.svg";